import { render, staticRenderFns } from "./SeoBreadcrumbs.vue?vue&type=template&id=2f8458ba&scoped=true"
import script from "./SeoBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./SeoBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./SeoBreadcrumbs.vue?vue&type=style&index=0&id=2f8458ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8458ba",
  null
  
)

export default component.exports